import { render } from "./Sayt.vue?vue&type=template&id=5db519dd"
import script from "./Sayt.vue?vue&type=script&lang=js"
export * from "./Sayt.vue?vue&type=script&lang=js"

import exportComponent from "/builds/apps/elevate/shepherd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__